import { CloseIcon } from 'assets/icons/CloseIcon'
import { Modal } from 'components/Modal/Modal'
import { TextDisplayCard } from 'components/TextDisplayCard/TextDisplayCard'
import useModalClose from 'hooks/useModalClose'
import { CursorPointer, Flex, ItemsGrid, ModalScrollContainer, ThinSeparator } from 'styling/GlobalStyles'
import { BodyText, TitleText } from 'styling/Typography'
import { IInventoryRequestResponse } from 'types/api/inventoryRequestApi.interface'
import { formatDateForDisplay } from 'utils/helpers'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { getInventoryRequestStatusLabel } from './inventoryRequestsData'

interface IViewInventoryRequestModalProps {
  closeModal: () => void
  value?: IInventoryRequestResponse
}

export const ViewInventoryRequestModal = ({ closeModal, value }: IViewInventoryRequestModalProps) => {
  useFocusFirstInput()
  useModalClose(closeModal)

  const requesterName = value?.requestedByUser
    ? `${value.requestedByUser.firstName} ${value.requestedByUser.lastName}`
    : '/'

  const approverName = value?.approvedByUser
    ? `${value.approvedByUser.firstName} ${value.approvedByUser.lastName}`
    : '/'

  return (
    <Modal black>
      <ModalScrollContainer>
        <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
          <TitleText weight='bold'>Request Preview</TitleText>
          <CursorPointer onClick={closeModal}>
            <CloseIcon />
          </CursorPointer>
        </Flex>
        <ItemsGrid columns={2}>
          <TextDisplayCard width='100%' title={formatDateForDisplay(value?.createdAt)} labelText='Created At' />
          <TextDisplayCard width='100%' title={getInventoryRequestStatusLabel(value?.status)} labelText='Status' />
          <TextDisplayCard width='100%' title={value?.department?.name || '/'} labelText='Department' />
          <TextDisplayCard width='100%' title={value?.costCenter?.name || '/'} labelText='Cost Center' />
          <TextDisplayCard width='100%' title={requesterName} labelText='Requested By' />
          <TextDisplayCard width='100%' title={approverName} labelText='Approved By' />
          <TextDisplayCard
            width='100%'
            title={value?.approvedAt ? formatDateForDisplay(value.approvedAt) : '/'}
            labelText='Approved At'
          />
        </ItemsGrid>

        <TextDisplayCard style={{ marginTop: 16 }} title={value?.notes || '/'} labelText='Notes' width='100%' />

        {value?.declineReason && (
          <TextDisplayCard
            style={{ marginTop: 16 }}
            title={value.declineReason}
            labelText='Decline Reason'
            width='100%'
          />
        )}

        <ThinSeparator />
        <Flex column gap='1rem'>
          <BodyText weight='bold'>Items:</BodyText>
          {value?.lines?.length ? (
            value.lines.map((l) => (
              <Flex key={l.id} width='100%' gap='1rem'>
                <TextDisplayCard
                  width='100%'
                  title={l.inventoryItem ? l.inventoryItem.name : '/'}
                  labelText='Item'
                />
                <TextDisplayCard width='100%' title={l.quantity} labelText='Quantity' />
              </Flex>
            ))
          ) : (
            <BodyText>No items</BodyText>
          )}
        </Flex>
      </ModalScrollContainer>
    </Modal>
  )
}
